import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SERVER_BASE_URL } from '../../../environments/environment';
import { Observable } from 'rxjs';
import {
  EmailAndPhone,
  StandardCheckoutResponse,
  UserRegistrationDto,
  UserRegistrationForm,
} from '../user-service/user.service';
import { CurrencyCode } from '@app/model/currency';

@Injectable({
  providedIn: 'root',
})
export class PIAService {
  private readonly httpReqOptions = { withCredentials: true };
  webformId = '';
  finapiError = false;

  constructor(private http: HttpClient) {}

  registerUser(
    form: UserRegistrationForm
  ): Observable<StandardCheckoutResponse> {
    return this.http.post<StandardCheckoutResponse>(
      `${SERVER_BASE_URL}/user/pia/registerUser/`,
      form,
      this.httpReqOptions
    );
  }

  resendPhoneVerificationSms(): Observable<StandardCheckoutResponse> {
    return this.http.post<StandardCheckoutResponse>(
      `${SERVER_BASE_URL}/user/pia/resendPhoneVerificationSms/`,
      this.httpReqOptions
    );
  }

  commitToPiAPayment(): Observable<PayInAdvancePaymentJson> {
    return this.http.post<PayInAdvancePaymentJson>(
      `${SERVER_BASE_URL}/user/pia/commitToPiAPayment/`,
      this.httpReqOptions
    );
  }

  registerEmailAndPhone(
    user: EmailAndPhone
  ): Observable<StandardCheckoutResponse> {
    return this.http.post<StandardCheckoutResponse>(
      `${SERVER_BASE_URL}/user/pia/registerEmailAndPhone/`,
      user,
      this.httpReqOptions
    );
  }

  verifyPhone(verificationCode: string): Observable<StandardCheckoutResponse> {
    return this.http.post<StandardCheckoutResponse>(
      `${SERVER_BASE_URL}/user/pia/verifyPhone/`,
      { code: verificationCode },
      this.httpReqOptions
    );
  }

  verifyEmail(verificationCode: string): Observable<StandardCheckoutResponse> {
    return this.http.post<StandardCheckoutResponse>(
      `${SERVER_BASE_URL}/user/pia/verifyEmail/`,
      { code: verificationCode },
      this.httpReqOptions
    );
  }

  sendEmailVerificationEmail(): Observable<StandardCheckoutResponse> {
    return this.http.post<StandardCheckoutResponse>(
      `${SERVER_BASE_URL}/user/pia/sendEmailVerificationEmail/`,
      this.httpReqOptions
    );
  }

  getPreExistingContactInfo(): Observable<UserRegistrationDto> {
    return this.http.get<UserRegistrationDto>(
      `${SERVER_BASE_URL}/user/pia/getPreExistingContactInfo/`,
      this.httpReqOptions
    );
  }

  getActiveUserInfo(): Observable<UserRegistrationDto> {
    return this.http.get<UserRegistrationDto>(
      `${SERVER_BASE_URL}/user/pia/getActiveUserInfo/`,
      this.httpReqOptions
    );
  }
}

export interface PayInAdvancePaymentJson {
  amount: Number;
  currencyCode: CurrencyCode;
  status: PiAStatus;
  paymentReference: string;
  paymentViban: string;
  bankName: string;
  bic: string;
}

export enum PiAStatus {
  CREATED = 'CREATED',
  CONFIRMED = 'CONFIRMED',
  CANCELLED = 'CANCELLED',
  EXPIRED = 'EXPIRED',
}
